export interface GlobalProps {
  'data-ink': boolean;
  'data-ink-deprecated'?: boolean;
  'data-ink-deprecated-props'?: boolean;
  'data-ink-sunset'?: boolean;
  'data-ink-ink-sass'?: boolean;
}

const getGlobalProps = ({
  deprecated,
  deprecatedProps,
  sunset,
  inkSass,
}: {
  deprecated?: boolean;
  deprecatedProps?: boolean;
  sunset?: boolean;
  inkSass?: boolean;
}): GlobalProps => {
  return {
    'data-ink': true,
    'data-ink-deprecated': deprecated ? true : undefined,
    'data-ink-deprecated-props': deprecatedProps ? true : undefined,
    'data-ink-sunset': sunset ? true : undefined,
    'data-ink-ink-sass': inkSass ? true : undefined,
  };
};

export default getGlobalProps;
